import { Role } from '../../../../../common';
import { UserRolesModel } from '../../user';

export class NewsletterType {
  id: number;
  name: string;
  roles: Role[] | UserRolesModel;
  constructor(params?: NewsletterType) {
    Object.assign(this, params);
  }
}
